import Blue from "../core";
import Swiper, { Navigation, Pagination, A11y } from "swiper";

new Blue({
	name: 'Swiper Carousel',
	selector: ".carousel-swiper",
	setup(carousel) {
		const carouselEl = carousel.querySelector(".carousel-swiper__container");
		const wrapper = carousel.querySelector(".carousel-swiper__wrapper");
		const slides = [...carousel.querySelectorAll(".carousel-swiper__slide")];
		const prevBtn = carousel.querySelector(".carousel-swiper__button-prev");
		const nextBtn = carousel.querySelector(".carousel-swiper__button-next");
		const pagination = carousel.querySelector(".carousel-swiper__pagination");
		
		// Set unique id value in case multiple carousels on same page
		const idVal = "carousel-swiper-" + Math.ceil(Math.random() * 5000) * Math.ceil(Math.random() * 5000);
		carousel.setAttribute("id", idVal);

		// Data attribute values can be used to configure swiper from markup if used
		const checkForAttrVal = (attr) => {
			let val = carousel.getAttribute(attr) || 'cs-fail';
			if (val === 'cs-fail') return null;
			else return JSON.parse(val);
		}
		const options = {
			slideCount: {
				desktop: checkForAttrVal("data-slides-desktop"),
				tablet: checkForAttrVal("data-slides-tablet"),
				largePhone: checkForAttrVal("data-slides-large-phone"),
				smallPhone: checkForAttrVal("data-slides-small-phone"),
			},
			singleSlideTransition: checkForAttrVal("data-single-slide-transition")
		}
		const slidePerGroupVal = (slideCountProp, defaultVal) => {
			if (options.singleSlideTransition || options.singleSlideTransition === null) return 1;
			else if (options.slideCount[slideCountProp] === null) return defaultVal; 
			else return options.slideCount[slideCountProp];
		}

		// Add default classes to take advantage of swiper built-in styling
		carouselEl.classList.add("swiper");
		wrapper.classList.add("swiper-wrapper");
		slides.forEach(slide => slide.classList.add("swiper-slide"));
		prevBtn.classList.add("swiper-button-prev");
		nextBtn.classList.add("swiper-button-next");
		pagination.classList.add("swiper-pagination");

		// Init swiper
		const swiper = new Swiper(`#${idVal} .carousel-swiper__container`, {
			loop: true,
			modules: [Navigation, Pagination, A11y],
			simulateTouch: true,
			navigation: {
				nextEl: `#${idVal} .carousel-swiper__button-next`,
				prevEl: `#${idVal} .carousel-swiper__button-prev`,
			},
			pagination: {
				el: `#${idVal} .carousel-swiper__pagination`,
				type: 'bullets',
				clickable: true,
			},
			a11y: true,
			// Use data attribute values, if they exist, to configure at different breakpoints
			breakpoints: {
				0: {
					slidesPerView: options.slideCount.smallPhone===null?1:options.slideCount.smallPhone,
					spaceBetween: 20,
					slidesPerGroup: slidePerGroupVal('smallPhone', 1),
				},
				576: {
					slidesPerView: options.slideCount.largePhone===null?2:options.slideCount.largePhone,
					slidesPerGroup: slidePerGroupVal('largePhone', 2),
				},
				768: {
					slidesPerView: options.slideCount.tablet===null?3:options.slideCount.tablet,
					spaceBetween: 18,
					slidesPerGroup: slidePerGroupVal('tablet', 3),
				},
				992: {
					slidesPerView: options.slideCount.desktop===null?4:options.slideCount.desktop,
					spaceBetween: 16,
					slidesPerGroup: slidePerGroupVal('desktop', 4),
				}
			},
		});
	}
});